import {DashboardLayout} from "../../layout/dashboard.layout";
import {useTranslation} from "react-i18next";
import {DASHBOARD, TEMPLATES} from "../../../routes/frontend.routes";
import React, {useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {TemplateForm} from "./form";
import {jsonRequest} from "../../../../api/request/request";
import {TEMPLATE_EDIT, TEMPLATE_GET} from "../../../../api/routing/routes/backend.app";
import {HttpException, UnprocessableEntityException} from "../../../../lib/http/exception/http.exception";
import {useAlert} from "react-alert";
import {useNavigate} from "react-router";
import {Template} from "../../../../api/model/sent";

export const UpdateTemplate = () => {
  const {t} = useTranslation();
  const alert = useAlert();
  const params = useParams();
  const id = params.id as string;

  const [isSubmitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();
  const [template, setTemplate] = useState<Template>();

  const loadTemplate = async () => {
    try {
      const res = await jsonRequest(TEMPLATE_GET.replace(':id', id));
      const json = await res.json();

      setTemplate(json.template);
    } catch (e) {
      if (e instanceof HttpException) {
        alert.error(e.message);
      }

      throw e;
    }
  }

  useEffect(() => {
    loadTemplate();
  }, []);

  const onSubmit = async (values: any) => {
    setSubmitting(true);
    setErrors([]);

    try {
      await jsonRequest(TEMPLATE_EDIT.replace(':id', id), {
        method: 'POST',
        body: JSON.stringify(values)
      });

      navigate(TEMPLATES);
    } catch (e) {
      if (e instanceof UnprocessableEntityException) {
        const err = await e.response.json();
        setErrors(err.violations);
      }

      if (e instanceof HttpException) {
        alert.error(e.message);
      }

      throw e;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <DashboardLayout
      title="Templates"
      breadCrumbs={[
        {title: t('Dashboard'), link: DASHBOARD},
        {title: t('Templates'), link: TEMPLATES},
        {title: t('Update'), current: true},
      ]}
      buttons={[
        <Link to={TEMPLATES} className="float-end btn btn-primary">{t('Back to list')}</Link>
      ]}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                {t('Update')}
              </h5>
              <TemplateForm
                onSubmit={onSubmit}
                isSubmitting={isSubmitting}
                errors={errors}
                template={template}
              />
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
